import {
  CheckNotes,
  InspectionCase,
  InspectionValueCase,
  InspectionValueCaseDto
} from '../../inspection-cases';

export class PressureSystemDto extends InspectionCase {
  location?: InspectionValueCaseDto;
}

export class PressureSystem extends PressureSystemDto {
  constructor(
    data: PressureSystemDto = {
      title: 'הסנקה'
    }
  ) {
    super(data);
    this.location = new InspectionValueCase({
      ...data.location,
      title: 'תאר את מיקום ההסנקה'
    });
  }

  setInspectionStatus(): void {
    this.isPassed =
      !this.isApplicable ||
      !this.location.isApplicable ||
      this.location.isPassed;
  }

  getNotes?(): CheckNotes[] {
    if (!this.isApplicable) {
      return [];
    }
    return [...this.location.getNotes()];
  }
}
